import React from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";

function ConfirmationModal({handleClose, deleteId, show}) {
  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>{t('delete_confirmation')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t('delete_confirmation_text')}</Modal.Body>
      <Modal.Footer>

        <div className="white-border-btn cancel-btn" onClick={() => handleClose(false)}>{t('cancel')}</div>
        
        <div style={{flexGrow: 1}} />
        
        <div className="white-border-btn delete-btn" onClick={() => handleClose(true, deleteId)}>{t('delete')}</div>

      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmationModal;
